// frontend_react/src/components/cash/CashSessionBanner.jsx

import React from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/cart.css";

export default function CashSessionBanner({
  cashSession,
  onClose,
  onCloseClick,
  compact = false,
}) {
  const navigate = useNavigate();

  if (!cashSession?.is_open) {
    return null;
  }

  const openedAt = cashSession.started_at
    ? new Date(cashSession.started_at).toLocaleTimeString("fr-FR", {
        hour: "2-digit",
        minute: "2-digit",
      })
    : "—";

  const handleNavigate = (url) => {
    onClose?.();
    navigate(url);
  };

  const handleCloseCash = () => {
    onClose?.();

    if (onCloseClick) {
      onCloseClick();
    }
  };

  return (
    <div
      className="cash_session_overlay"
      onClick={onClose}
    >
      <div
        className="cash_session_modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className={`cash_session_banner ${
            compact ? "compact" : ""
          }`}
        >
          <div className="cash_session_status">
            <span className="cash_status_dot" />

            <div>
              <strong>Caisse ouverte</strong>

              <span>
                Fond :{" "}
                {Number(
                  cashSession.opening_cash || 0
                ).toFixed(2)}{" "}
                €
              </span>

              <span>
                Ouverte à : {openedAt}
              </span>

              <span>
                Session :{" "}
                {cashSession.cash_session_uuid}
              </span>
            </div>
          </div>

          <div className="cash_session_actions">
            <button
              type="button"
              onClick={() =>
                handleNavigate(
                  "/admin?panel=x_report"
                )
              }
            >
              X de caisse
            </button>

            <button
              type="button"
              onClick={() =>
                handleNavigate(
                  "/admin?panel=z_report"
                )
              }
            >
              Clôture Z
            </button>

            <button
              type="button"
              onClick={() =>
                handleNavigate(
                  "/admin?panel=cash_dashboard"
                )
              }
            >
              Dashboard caisse
            </button>

            <button
              type="button"
              disabled
            >
              Historique Z
            </button>

            <button
              type="button"
              disabled
            >
              Réimprimer ticket
            </button>

            {onCloseClick && (
              <button
                type="button"
                className="danger"
                onClick={handleCloseCash}
              >
                Clôturer la caisse
              </button>
            )}
          </div>

          <button
            type="button"
            className="cash_session_close"
            onClick={onClose}
          >
            Fermer
          </button>
        </div>
      </div>
    </div>
  );
}